import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AppFloatingConfigurator } from '../../layout/component/app.floatingconfigurator';
import { Location } from '@angular/common';

@Component({
    selector: 'app-notfound',
    standalone: true,
    imports: [RouterModule, AppFloatingConfigurator, ButtonModule],
    templateUrl: "./notfound.html"
})
export class Notfound {

    constructor(private readonly location: Location) {

    }
    
    returnPageBack() {
        this.location.back();
    }
}
